<template>
<div id="nissan-quiz-readytoplay-ipad" class="nissan-quiz-screen">
    <div class="text-block">
        <v-container v-if="config.tierType === 'TSF' || config.tierType === 'TIER3' || config.tierType === 'CORP'">
            <h1>Get ready to play,</h1>
            <p >Hit Next to proceed!</p>
        </v-container>
        <v-container v-else>
            <h1>Ready To Play?</h1>
            <p >In order to begin, hit next!</p>
        </v-container>
        <div
          @click="readyToPlay"
          id="ReadyToPlayNextButton"
          class="nissan-quiz-nextbutton"
        >
          <span>NEXT</span>
        </div>
    </div>
    <div class="disclaimer" v-if="config.tierType === 'TIER3'">
      To register you must be 18 years of age.
    </div>
    <div class="disclaimer" v-else>
        To claim your prize you must be 18 years of age and present in the Nissan booth during the live game.
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReadyToPlay',

  computed: {
    ...mapGetters([
      'config',
    ]),
  },
  methods: {
    readyToPlay() {
      this.$store.commit('setUserReady', { value: true });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';

.text-block {
  font-size: 10px;
  text-align: center;
  margin: 10px 0;
}

h1 {
  color: #fff;
  font-size: 20px;
}
p {
  margin-top: 10px;
  font-size: 24px;
}

@media only screen and (min-width: 600px) {
  .text-block {
    font-size: 14px;
    margin: 75px 90px 0;
  }
  h1 {
    font-size: 60px;
  }
}
@media only screen and (max-width: 320px) {
  h1 {
    font-size: 15px;
  }
  .text-block > p {
    font-size: 14px;
  }
}

#nissan-quiz-readytoplay-ipad {
  top: 0;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
</style>
